import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { SessionLockOverlay, SessionExpiredOverlay } from './ui/SessionOverlays';

/**
 * SessionManager - renders session lock/expiry overlays globally
 * Only shown when user is authenticated
 */
export default function SessionManager() {
  const { user, sessionLocked, sessionExpired } = useAuth();

  if (!user) return null;

  if (sessionExpired) return <SessionExpiredOverlay />;
  if (sessionLocked) return <SessionLockOverlay />;

  return null;
}
